import { atom, useAtom } from "jotai";

import { defaultUnderlying } from "#/config/markets";
import { type PortfolioSymbolType } from "#/types/markets";

export const equityModalPortfolioAtom =
  atom<PortfolioSymbolType>(defaultUnderlying);

export const useEquityModalPortfolio = () => {
  const [equityModalPortfolio, setEquityModalPortfolio] = useAtom(
    equityModalPortfolioAtom,
  );

  return {
    equityModalPortfolio,
    setEquityModalPortfolio,
  };
};
